import React, { createContext, useReducer } from "react"

import { initialState, globalReducer } from "./GlobalStore"

export const GlobalContext = createContext()

const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(globalReducer, initialState)
  return (
    <GlobalContext.Provider value={[state, dispatch]}>
      {children}
    </GlobalContext.Provider>
  )
}

export default GlobalProvider
